import { useMMKVString } from 'react-native-mmkv';

import { storage, storageKeys } from '@/constants/storage';

import { useAppointmentLookupQuery } from '../queries/appointment/useAppointmentLookupQuery';
import { useCustomerStateQuery } from '../queries/customer/useCustomerStateQuery/useCustomerStateQuery';

export function useCustomerAppointment(enabled: boolean = true) {
  const [customerId = ''] = useMMKVString(storageKeys.customerId, storage);

  const {
    data: appointment,
    isLoading: isLoadingAppointment,
    confirmationCode,
  } = useAppointmentLookupQuery({ enabled });

  const { data: customer, isLoading: isLoadingCustomer } =
    useCustomerStateQuery({ customerId, enabled: enabled && !!customerId });

  return {
    confirmationCode,
    // data: !!customer?.appointment ? customer : (appointment ?? customer),
    data: Object.assign({}, customer, appointment),
    isLoading: isLoadingAppointment || isLoadingCustomer,
  };
}
